import { useMutation } from "react-query";
import http from "infra/http";

function useConfirmarReserva() {
  return useMutation(
    (id: string) => {
      return http.post(`/v1/reserva/${id}/confirmar`);
    },
    { retry: false }
  );
}

export default useConfirmarReserva;
